import { render, staticRenderFns } from "./ChangeOrder.vue?vue&type=template&id=54a7d368&scoped=true&"
import script from "./ChangeOrder.vue?vue&type=script&lang=js&"
export * from "./ChangeOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrder.vue?vue&type=style&index=0&id=54a7d368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7d368",
  null
  
)

export default component.exports